let get_editCusInv = function() {
	if (Object.keys(this.get_editCusInv).length > 0) {
		this.getDataBilling();
	}
};
export default get_editCusInv;
